import { useEffect, useState } from "react";
import { Loader2, MessageCircleQuestion, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminQuestions() {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/questions")
      .then((response) => setQuestions(response.data?.questions || []))
      .catch((err) => toast.error(formatApiError(err.response?.data?.detail)))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this question from the question room?")) return;
    try {
      await api.delete(`/admin/questions/${id}`);
      setQuestions((items) => items.filter((item) => item.id !== id));
      toast.success("Question deleted.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <section className="rounded-2xl border border-border bg-cream p-6 md:p-7">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-terracotta"><MessageCircleQuestion className="h-4 w-4" /> Ask Agnes</p>
          <h2 className="mt-2 font-serif text-2xl font-semibold text-forest">Question room</h2>
          <p className="mt-1 text-sm text-forest/60">Review the questions visitors have left.</p>
        </div>
        <span className="rounded-full bg-terracotta/10 px-3 py-1 text-sm font-medium text-terracotta">{questions.length}</span>
      </div>
      {loading ? <div className="mt-6 flex items-center gap-2 text-sm text-forest/50"><Loader2 className="h-4 w-4 animate-spin" /> Loading questions...</div> : questions.length === 0 ? <p className="mt-7 rounded-xl bg-muted/60 p-6 text-center text-sm text-forest/50">No questions have arrived yet.</p> : (
        <div className="mt-6 divide-y divide-border">
          {questions.map((item) => <div key={item.id} className="flex items-start justify-between gap-5 py-5 first:pt-0 last:pb-0">
            <div className="min-w-0"><span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-terracotta">{item.category}</span><p className="mt-1 font-serif text-lg leading-snug text-forest">“{item.question}”</p><p className="mt-2 text-xs text-forest/50">{item.asker_name || "Anonymous visitor"} · {item.created_at ? new Date(item.created_at).toLocaleDateString() : "Recently"}</p></div>
            <button onClick={() => remove(item.id)} data-testid={`button-delete-question-${item.id}`} aria-label={`Delete question ${item.id}`} className="shrink-0 rounded-lg p-2 text-forest/35 transition hover:bg-destructive/10 hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
          </div>)}
        </div>
      )}
    </section>
  );
}